/** Canonical route paths used by the public user screens. */
export const userRoutePaths = {
    login: '/login',
    logout: '/logout',
    profile: '/profil-uzivatele',
};
